import React from 'react';
import { useTranslation } from 'react-i18next';
import './LoadingOverlay.css'; // We'll define styles separately


export default function LoadingOverlay({ message, translate = false }) {
  const { t } = useTranslation();
  const loadingMessage = message ? (translate ? t('message') : message) : t('common.loading');
  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="loading-spinner">
            <div className="spinner-ring" />
            <img src="/logo192.png" alt="Logo" className="center-logo" />
        </div>
        <p className="loading-message">{loadingMessage}</p>
      </div>
    </div>
  );
}
